export default "__VITE_ASSET__MOZGDcEy__"